/**
 * Pie de modal anclado: las acciones (Guardar / Cancelar) dejan de scrollear con
 * el cuerpo y quedan visibles desde que el modal se abre.
 *
 * `DialogContent` aplica `max-h-[85dvh] overflow-y-auto` al CONTENEDOR ENTERO, así
 * que el pie scrollea junto al formulario. Medido con Playwright antes de
 * arreglarlo, a 1366x768:
 *
 *   "Nuevo empleado"  contenido 1546px, 895px que scrollear  → Guardar a +873px
 *   "Nuevo gasto"     contenido 1768px, 1117px que scrollear → Guardar a +1095px
 *
 * Y no es cosa de pantallas pequenas: repetido a 1920x1440 el Guardar del gasto
 * SEGUIA fuera de vista — harian falta 2080px de alto. En ninguna pantalla real
 * se veia ese boton al abrir el modal.
 *
 * Los margenes negativos horizontales sangran la banda hasta los bordes del
 * contenedor (`p-4 sm:p-6` en la base del dialogo).
 *
 * El anclaje va a `-bottom-4 sm:-bottom-6`, NO a `bottom-0`: `sticky bottom-0` pega
 * la banda al borde del CONTENT box, que esta a un padding del borde real del
 * modal, y por esa franja se seguia viendo pasar el formulario por debajo del pie
 * — se ve en cuanto se mira una captura, aunque la medicion del boton ya diera
 * "visible". Desplazarlo el padding hacia abajo lo pega al borde del padding box,
 * que es el borde del modal; el `pb-*` mantiene el aire bajo los botones.
 *
 * El fondo va ADEMAS por `style` inline en cada componente que la usa: sobre la
 * superficie `liquid` el `.lg-glass` gana por especificidad a la utilidad Tailwind
 * y el overlay oscuro se transparenta, tinendo la banda de gris. Es la misma
 * guerra de especificidad que ya documenta `FormModal.jsx`, donde `bg-card` se
 * queda como fallback SSR/no-JS.
 *
 * El patron ESTRUCTURAL correcto es el de `FormModal` (contenedor
 * `flex flex-col overflow-hidden`, cuerpo `flex-1 overflow-y-auto`, pie
 * `shrink-0`), pero exige que el modal tenga exactamente tres hijos. Los ~185
 * modales afectados cuelgan N hijos sueltos del `DialogContent`, asi que se usa
 * `sticky`, que es tolerante a cualquier estructura interna y se ancla sobre el
 * contenedor que YA scrollea.
 *
 * ── Por que este fichero existe, en vez de vivir en `lib/utils` ──
 *
 * Porque `lib/utils` esta MOCKEADO por medio repo. Diez ficheros de test hacen
 * `vi.mock('@/lib/utils', ...)` devolviendo solo `cn`, sin `importOriginal`, y
 * vitest lanza al acceder a un export que el mock no declara:
 *
 *   Error: [vitest] No "PIE_MODAL_ANCLADO" export is defined on the
 *   "@/lib/utils" mock. Did you forget to return it from "vi.mock"?
 *
 * Fueron 42 tests en rojo, todos de `AlertDialog`. El modulo propio los deja en
 * verde sin duplicar la cadena en los cuatro primitivos y sin tocar ningun test.
 * Si algun dia alguien mockea ESTE fichero, el mismo problema vuelve.
 */
export const PIE_MODAL_ANCLADO =
  // `z-sticky`, no `z-10`: la guia tiene escala nombrada
  // (`z-dropdown < z-sticky < z-overlay < z-modal …`) y prohibe los numeros magicos.
  'sticky -bottom-4 sm:-bottom-6 z-sticky -mx-4 sm:-mx-6 px-4 sm:px-6 pb-4 sm:pb-6 pt-3 ' +
  'bg-card border-t border-border';

/** Fondo opaco del pie anclado — ver `PIE_MODAL_ANCLADO`: por `style`, no por clase. */
export const PIE_MODAL_ANCLADO_STYLE = { backgroundColor: 'hsl(var(--card))' } as const;
